import { Badge } from "@/deps/ui-library";
import type { ColorScheme } from "@/deps/ui-library";
import type { DocumentStatus, PaymentStatus } from "@/api/types";

const DOCUMENT: Record<DocumentStatus, { label: string; scheme: ColorScheme }> = {
  draft: { label: "Draft", scheme: "default" },
  submitted: { label: "Submitted", scheme: "info" },
  verified: { label: "Verified", scheme: "info" },
  approved: { label: "Approved", scheme: "success" },
  void: { label: "Void", scheme: "danger" },
};

const PAYMENT: Record<PaymentStatus, { label: string; scheme: ColorScheme }> = {
  unpaid: { label: "Unpaid", scheme: "default" },
  partiallyPaid: { label: "Partially paid", scheme: "warning" },
  paid: { label: "Paid", scheme: "success" },
  overdue: { label: "Overdue", scheme: "danger" },
};

/** A document's place in the approval ladder. */
export function DocumentStatusBadge({ status }: { status: DocumentStatus }) {
  const { label, scheme } = DOCUMENT[status];
  return (
    <Badge variant="soft" size="sm" colorScheme={scheme}>
      {label}
    </Badge>
  );
}

/**
 * A document's payment state. Separate from the status badge because they answer different
 * questions — "has anyone approved this" and "has anyone paid it" — and a single combined chip
 * makes an approved-but-overdue invoice indistinguishable from an unapproved one.
 */
export function PaymentStatusBadge({ status }: { status: PaymentStatus }) {
  const { label, scheme } = PAYMENT[status];
  return (
    <Badge variant="soft" size="sm" colorScheme={scheme}>
      {label}
    </Badge>
  );
}
